import axios from 'axios';
import uuidv4 from 'uuid/v4';

export default {
  namespaced: true,
  state: {
    menuVo: {
      list: []
    },
    // ruleForm: {
    //   name: null,
    //   menuType: '发送消息',
    //   key: '',
    //   url: '',
    //   msgType: '1'
    // },
    // currentName: '',
    // currentId: '',
    currentIndex: 0,
    // currentParentId: '',
    currentParentIndex: 0,
    // nameTip: '字数不超过4个汉字或8个字母',
    // menuRight: false,
    picWordList: [],
    keyValue: ''
  },
  mutations: {
    menuValidate(state, {
      list
    }) {
      if (list) {
        state.menuVo.list = list;
        state.menuVo.list.forEach(item => {
          item.id = uuidv4();
          item.msgType = String(item.msgType);
          item.menuGroupCode = item.menuGroupCode ? String(item.menuGroupCode) : '200'; //物业服务-信息内容
          item.maximumCount = item.maximumCount ? String(item.maximumCount) : '8'; //物业服务最大条数
          item.msgTypeForView = item.msgTypeForView ? String(item.msgTypeForView) : '3'; //跳转页面的 msgType
          item.menuGroupCodeForView = item.menuGroupCodeForView ? String(item.menuGroupCodeForView) : '400'; //跳转页面-可选服务（默认报事报修）
          if (item.type === 'activity_click') {
            item.keyA = item.key;
            item.key = '';
          }
          if (item.subButton.length > 0) {
            item.subButton.forEach(itm => {
              itm.id = uuidv4();
              itm.msgType = String(itm.msgType);
              itm.menuGroupCode = itm.menuGroupCode ? String(itm.menuGroupCode) : '200'; //物业服务-信息内容
              itm.maximumCount = itm.maximumCount ? String(itm.maximumCount) : '8'; //物业服务最大条数
              itm.msgTypeForView = itm.msgTypeForView ? String(itm.msgTypeForView) : '3'; //跳转页面的 msgType
              itm.menuGroupCodeForView = itm.menuGroupCodeForView ? String(itm.menuGroupCodeForView) : '400'; //跳转页面-可选服务（默认报事报修）
              if (itm.type === 'activity_click') {
                itm.keyA = itm.key;
                itm.key = '';
              }
            });
          }
        });
        // if (state.menuVo.list.length > 0) {
        //   state.menuRight = true;
        //   state.currentParentId = state.menuVo.list[0].id;
        //   if (state.menuVo.list[0].subButton.length > 0) {
        //     state.currentId = state.menuVo.list[0].subButton[0].id;
        //     state.ruleForm.name = state.currentName = String(state.menuVo.list[0].subButton[0].name);
        //     state.ruleForm.menuType = state.menuVo.list[0].subButton[0].type === 'click' ? '发送消息' : '发送链接';
        //     state.ruleForm.key = state.menuVo.list[0].subButton[0].key;
        //     state.ruleForm.url = state.menuVo.list[0].subButton[0].url;
        //     state.ruleForm.msgType = state.menuVo.list[0].subButton[0].msgType;
        //     state.nameTip = '字数不超过8个汉字或16个字母';
        //   } else {
        //     state.currentId = state.menuVo.list[0].id;
        //     state.ruleForm.name = state.currentName = String(state.menuVo.list[0].name);
        //     state.ruleForm.menuType = state.menuVo.list[0].type === 'click' ? '发送消息' : '发送链接';
        //     state.ruleForm.key = state.menuVo.list[0].key;
        //     state.ruleForm.url = state.menuVo.list[0].url;
        //     state.ruleForm.msgType = state.menuVo.list[0].msgType;
        //     state.nameTip = '字数不超过4个汉字或8个字母';
        //   }
        // }
      } else {
        return;
      }
    },
    setCurrentName(state, value) {
      state.currentName = String(value);
    },
    setCurrentId(state, value) {
      state.currentId = value;
    },
    setCurrentIndex(state, value) {
      state.currentIndex = value;
    },
    setCurrentParentId(state, value) {
      state.currentParentId = value;
    },
    setCurrentParentIndex(state, value) {
      state.currentParentIndex = value;
    },
    setNameTip(state, value) {
      state.nameTip = value;
    },
    setMenuRight(state, value) {
      state.menuRight = value;
    },
    setPicWordList(state, value) {
      state.picWordList = value;
    },
    setKeyValue(state, value) {
      state.keyValue = value;
    },
    setList(state, value) {
      state.menuVo.list.push(value);
    }
  },
  actions: {
    menuQuery({
      commit
    }, params) {
      return axios.get('/wxmenu/ajax/menuGet', {
        params: params,
      }).then((data) => {
        commit({
          type: 'menuValidate',
          list: data.data
        });
        return data;
      });
    },
    menuSave({
      commit
    }, params) {
      return axios.post('/wxmenu/ajax/menuSet', params).then((data) => {
        return data;
      });
    }
  },
};
